import { render, staticRenderFns } from "./MessageVue.vue?vue&type=template&id=86586f54&scoped=true"
import script from "./MessageVue.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageVue.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageVue.vue?vue&type=style&index=0&id=86586f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86586f54",
  null
  
)

export default component.exports